<template>
  <div :class="itemList.length<0?'isList':''" class="babyGranary">
    <!-- 改版头部 -->
    <div :class="itemList.length<0?'isList':''" class="granary-con">
      <div>
        <div class="static_img">
          <img alt="" src="https://image-mom.feihe.com/upload/2021/08/5a64f9e2-61c6-4657-8791-eb2b58bad9f6.jpg">
        </div>
        <div class="granary-header">
          <!-- <img class='back-img'  src="../../assets/images/babyGranary/bg.png" alt="">  -->
          <!-- <div> -->
          <span class="header-back" @click="toHomeHander">
            <img alt="" class="backimg" src="../../../assets/images/icon/back1.png">
          </span>
          <div class="header-left">
            <div :class="!storeFlag?'img-margin':'img-marginbuzu'" class="header-img">
              <img :src="require('./../../../assets/images/icon/'+statrImage)" class="img-buduo"/>
            </div>
            <!-- 气泡贴纸 -->
            <div :class="{'header-pasterbuzu':storeFlag&&!jianyiFlag}" class='header-paster'>
              <div :class="chongzuFlag? 'header-desc-chongzu':''" class="header-desc"></div>
            </div>
          </div>
          <!-- 屯粮 -->
          <div v-if="storeFlag"
               :class="`${isShow&&isShowFirst?'store-food-second':''} ${isShow&&isShowFirst&&memberWeight&&memberWeightSecond?'recommendTop':''}`"
               class="store-food">
            <div v-if="isShowFirst" class="first-baby first">
              <div class="intake">
                {{ firstBabyName }}
                <span style="marginLeft:0px">
                  <br v-if="firstBabyName.length>5"/>今日需摄入
                </span>
              </div>
              <div class="intake-weight">
                <span class="point"></span>
                <span class="ml">{{ memberFirstWeight }}ml</span>
                <span v-if="editFlag" @click="editGranary(1)">
                  <img alt height="12px" src="../../../assets/images/icon/edit.png" width="12px"/>
                </span>
              </div>
              <div v-if="memberWeight" class="sys-record">系统推荐</div>
            </div>

            <!-- 二胎 -->
            <div v-if="isShow" class="first-baby second">
              <div class="intake">
                {{ secondBabyName.trim() }}
                <span style="marginLeft:0px">
                  <br v-if="secondBabyName.trim().length>5"/>今日需摄入
                </span>
              </div>
              <div class="intake-weight">
                <span class="point"></span>
                <span class="ml">{{ memberSecondWeight }}ml</span>
                <span v-if="editFlag" @click="editGranary(2)">
                  <img alt height="12px" src="../../../assets/images/icon/edit.png" width="12px"/>
                </span>
              </div>
              <div v-if="memberWeightSecond" class="sys-record">系统推荐</div>
            </div>
            <!-- 奶量剩余天数 -->
            <div class="first-baby" style="margin-top:10px">
              <div class="intake">奶量剩余天数</div>
              <div class="intake-weight">
                <span :class="isRed?'isRed':''" class="point"></span>
                <span :class="isRed?'isRed':''" class="ml">{{ totalDays }}天</span>
              </div>
            </div>
            <div class="header-btn" @click="continueFood">
              <span v-if="bucangFlag">马上补仓</span>
              <span v-else>继续屯粮</span>
              <img alt src="../../../assets/images/icon/arrow.png"/>
            </div>
          </div>
          <!-- </div> -->
        </div>
        <!-- -->

        <!-- 内容 -->
        <div :class="itemList.length<0?'isList':''" class="granary-content">
          <!-- 库存 -->
          <div class="granary-remain">
            <p class="remain-title">当前库存</p>
            <div class="remain">
              <ul :class="{'twoMar':isMargin==2,'threeMar':isMargin==3}" class="remain-list">
                <li class="list-scan" @click="weiScanSHnader">
                  <div class="scan-img">
                    <img src="../../../assets/images/babyGranary/02granary.jpg"/>
                  </div>
                  <p class="scan-desc">新到口粮，扫积分码添加</p>
                </li>
                <li v-for="(item,index) in remainList" :key="item.id" class="list-item">
                  <div class="item-img">
                    <img v-if="item.pic != null" :src="item.pic"/>
                    <!-- <img src="../../assets/images/babyGranary/03granary.png" v-show="!item.pic"/> -->
                  </div>
                  <p class="item-desc">{{ title[index] }}</p>
                  <div class="item-num">
                    <span v-if="item.num>=0">{{ item.specs }}g/桶</span>
                    <div class="item-step" @click.capture="clickHander(index)">
                      <div class="minus" @click.stop="minusHander(index)"></div>
                      <div class="num" v-bind:class="{active:index==isActive}">{{ item.num > 99 ? '99+' : item.num }}
                      </div>
                      <div class="add" @click.stop="addHander(index)"></div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <!-- 库存记录 -->
          <div class="granary-record" @click="toListHander">
            <p class="record-title">库存记录</p>
            <p class="record-desc">宝宝吃过的奶粉都在这里哦～</p>
            <span class="record-btn"></span>
          </div>
        </div>
      </div>
    </div>

    <!-- 改版新增商品列表 -->
    <van-list v-if="itemList.length>0" v-model="loading" :finished="finished" :immediate-check="false" :offset="5"
              class="product-list-wrap" @load="onLoad">
      <!-- itemList换成你自己的数据 -->
      <div v-if="itemList.length>0" class="product-list-wrap">
        <ul class="product-list">
          <li v-for="(item,index) in itemList" v-if="item.promotion_type == 8 || item.promotion_type == 6" :key="index"
              :data='JSON.stringify(item)'
              :index='index' class="product-item"
              @click.stop="toProduct(item,index)">
            <img :src="item.imgUrl" alt height="134px" width="134px"/>
            <div class="product-title">{{ item.recommendGoods }}</div>
            <div class="product-desc">{{ item.recommendReason }}</div>
            <div v-if="item.promotion_type == 8" class="product-price">
              {{ item.point_price }}积分{{ `${item.flag == 1 ? '/' : '+'}￥${item.price}` }}
            </div>
            <div v-else-if="item.promotion_type == 6" class="product-price">{{ item.point_price }}积分</div>
            <div class="product-price-line">￥{{ item.lineValue }}</div>
          </li>
        </ul>
      </div>
    </van-list>

    <div class="granary-bottom">—我是有底线的—</div>

    <!-- 弹窗 -->
    <granary-dialog v-show="logShow" @closeDialog="cancelDialog" @wxScanFn="weiScanSHnader"></granary-dialog>
    <!-- 联系导购弹窗-->
    <div class="contact">
      <div class="contact-tel">
        <div class="contact-num">
          <p class="phone">{{ staffMobile }}</p>
          <p class="desc">您的专属营养顾问电话</p>
        </div>
        <div class="contact-select">
          <div class="del" @click="delTelHander">取消</div>
          <a :href="'tel:' + staffMobile" class="call">
            <div>呼叫</div>
          </a>
        </div>
      </div>
    </div>
    <!-- 食量弹窗 -->
    <van-popup v-model="editShow"
               :style="{height: '286px', borderRadius:'16px 16px 0px 0px',padding:'16px 12px',boxSizing:'border-box'} "
               class="edit"
               position="bottom">
      <div class="edit-popup">
        <span class="edit-cancel" @click.stop="cancelHander()">取消</span>
        <span class="edit-title">{{ babyName }}每日食量设置</span>
        <span class="edit-save" @click="saveHander()">保存</span>
      </div>
      <div class="edit-warn">*宝宝粮仓说明：调整宝宝食量将会纠正宝宝粮仓库存的消耗进度，可根据宝宝实际情况调整</div>
      <!-- 滑块儿 -->
      <div class="granary-adjust">
        <div class="adjust-title">{{ slider }} g/天</div>
        <div class="adjust-slider">
          <van-slider v-model="slider" :max="500" :min="0" :step="5" active-color="#D4A437" bar-height="6px"
                      @change="onChange">
            <div slot="button" class="custom-button"></div>
          </van-slider>
        </div>
        <p class="adjust-range">
          <span>0g</span>
          <span>500g</span>
        </p>
        <p class="desc">{{ month }}月龄宝宝建议每日摄入奶粉{{ systemWeight }}g/天</p>
      </div>
    </van-popup>
  </div>
</template>

<style lang="less" scoped>
.babyGranary {
  min-height: 100%;
  padding: 0 12px;
  background: rgba(242, 242, 242, 1);
  box-sizing: border-box;

  &.isList {
    height: 100%;
  }

  .granary-con {
    width: 351px;
    height: 100%;
    background: url("../../../assets/images/babyGranary/back.png") no-repeat;
    background-size: 100% 100%;
    border-top: 10px solid #f2f2f2;
    box-sizing: border-box;

    &.isList {
      padding-top: 120px;
      box-sizing: border-box;
    }

    .static_img {
      width: 100%;

      > img {
        max-width: 100%;
        height: auto;
      }
    }
  }

  //头部
  .granary-header {
    width: 100%;
    height: 293px;
    overflow: hidden;
    position: relative;

    .header-back {
      z-index: 100;
      width: 26px;
      position: fixed;
      top: 7px;
      left: 7px;

      img {
        width: 26px;
        height: 26px;
      }
    }

    .header-img {
      width: 167px;
      height: 180px;
      text-align: center;
      line-height: 196px;

      img {
        width: 100%;
        height: 100%;
      }

      //background: url(.././../assets/images/icon/chongzu.png)  no-repeat center center ;
      //background-size: 52px 52px;
      .img-buduo {
        vertical-align: middle;
        display: inline-block;
      }
    }

    .img-margin {
      margin: 83px 77px 14px 77px;
    }

    .img-marginbuzu {
      margin: 77px 136px 20px 18px;
    }

    .header-paster {
      height: 70px;
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      top: 19px;
      left: 15px;
      z-index: 50;
      box-sizing: border-box;
      background: url(../../../assets/images/babyGranary/tiezhi1.png) no-repeat;
      background-size: 97% 100%;

      .header-desc {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(121, 51, 40, 1);
        line-height: 14px;
        font-size: 12px;
        transform: scale(0.83);
        text-align: center;
      }
    }

    .header-pasterbuzu {
      width: 88px;
      height: 63px;
      position: absolute;
      //padding: 18px 0px 6px 0px;
      top: 26px;
      left: 56px;
      z-index: 50;
      box-sizing: border-box;
      background: url(../../../assets/images/babyGranary/tiezhi2.png) no-repeat;
      background-size: 100% 100%;

      .header-desc {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(121, 51, 40, 1);
        line-height: 14px;
        font-size: 12px;
        transform: scale(0.83);
        //text-indent: 8px;
        margin-top: -6px;
        text-indent: 0;

      }
    }

    .header-pasterbuzu {
      .header-desc-chongzu {
        // text-indent: 0;
        // text-align: center;
      }
    }

    //屯粮
    .store-food-second {
      top: 54px !important;
    }

    .recommendTop {
      top: 40px !important;
    }

    .store-food {
      //width: 84px;
      position: absolute;
      top: 109px;
      left: 227px;

      .first-baby {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        margin-bottom: 14px;

        .intake {
          font-size: 12px;
          //height: 17px;
          color: rgba(102, 102, 102, 1);
          line-height: 17px;
        }

        .intake-weight {
          font-size: 13px;
          color: rgba(12, 135, 50, 1);
          line-height: 18px;
          display: flex;
          align-items: center;

          .point {
            width: 3px;
            height: 3px;
            background: rgba(12, 135, 50, 1);
            border-radius: 50%;
            //margin-top: 0.01rem;
            &.isRed {
              background: #ef6b6b;
            }
          }

          .ml {
            margin: 0 5px 0 6px;

            &.isRed {
              color: #ef6b6b;
            }
          }
        }

        .sys-record {
          width: 56.7px;
          height: 17.91px;
          box-sizing: border-box;
          background: rgba(85, 177, 255, 1);
          border-radius: 6px;
          font-size: 12px;
          transform: scale(0.67);
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 17.91px;
          text-align: center;
          margin-left: -5px;
        }
      }

      .header-btn {
        width: 78px;
        height: 24px;
        display: flex;
        align-items: center;
        background: linear-gradient(270deg,
        rgba(215, 168, 92, 1) 0%,
        rgba(231, 196, 121, 1) 100%);
        border-radius: 14px;
        justify-content: center;
        box-sizing: border-box;
        margin-bottom: 7px;
        //padding-top: 2px;
        span {
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }

        img {
          width: 5px;
          height: 9px;
          margin-left: 5px;
        }
      }
    }
  }

  //内容
  .granary-content {
    height: 310px;

    &.isList {
      margin-top: 30px;
    }

    //库存
    .granary-remain {
      height: 237px;
      padding-left: 9px;

      .remain-title {
        padding-top: 20px;
        font-size: @indexFontSize12;
        font-weight: bold;
        color: @expertFontColor51;
        line-height: 1;
      }

      .remain {
        padding-top: 20px;

        .remain-list {
          // width: 363px;
          height: 178px;
          white-space: nowrap;
          overflow-x: auto;

          .list-scan,
          .list-item {
            display: inline-block;
            width: 128px;
            height: 168px;
            background: @expertFontColor255;
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
            border-radius: 8px;
            margin-right: 9px;
          }

          //扫一扫
          .list-scan {
            text-align: center;
            position: relative;
            overflow: hidden;
            // top: -3px;

            //扫一扫
            .scan-img {
              text-align: center;

              img {
                width: 56px;
                height: 56px;
                margin-top: 38px;
              }
            }

            .scan-desc {
              text-align: center;
              white-space: pre-wrap;
              margin: 17px auto;
              width: 90px;
              height: 36px;
              font-size: @indexFontSize12;
              color: rgba(180, 180, 180, 1);
              line-height: 18px;
            }
          }

          .list-item {
            display: inline-block;
            overflow: hidden;

            .item-img {
              width: 78px;
              height: 78px;
              margin-top: 13px;
              margin-left: 23px;
              background: url(../../../assets/images/babyGranary/03granary.png) no-repeat;
              background-size: 78px 78px;

              img {
                width: 100%;
                height: 78px;
                display: block;
              }
            }

            .item-desc {
              padding-left: 8px;
              padding-top: 20px;
              font-size: @indexFontSize12;
              line-height: 1;
              white-space: nowrap;
              width: 110px;
              text-overflow: ellipsis;
              overflow: hidden;
            }

            .item-num {
              margin-left: 8px;
              margin-top: 11px;
              height: 26px;
              display: flex;

              span {
                color: @expertFontColor153;
                font-size: @indexFontSize12;
                line-height: 14px;
                margin-right: 14px;
              }

              //步进器
              .item-step {
                display: flex;
                width: 53px;

                .minus,
                .add {
                  width: 14px;
                  height: 14px;
                  background-size: 14px 14px;
                }

                .minus {
                  background: url(../../../assets/images/babyGranary/minus.jpg) no-repeat;
                  background-size: 14px 14px;
                }

                .add {
                  background: url(../../../assets/images/babyGranary/add.jpg) no-repeat;
                  background-size: 14px 14px;
                }

                .num {
                  width: 25px;
                  font-size: @indexFontSize14;
                  color: @expertFontColor51;
                  line-height: 14px;
                  text-align: center;
                }

                //    .active{
                //        color: red;
                //    }
              }
            }
          }
        }
      }
    }
  }

  //记录
  .granary-record {
    border-top: 1px solid rgba(212, 164, 55, 1);
    height: 72px;
    padding-left: 9px;
    position: relative;

    .record-title {
      height: 16px;
      font-size: @indexFontSize12;
      font-weight: bold;
      color: @expertFontColor51;
      line-height: 16px;
      padding-top: 20px;
    }

    .record-desc {
      height: 12px;
      font-size: @indexFontSize12;
      font-family: PingFangSC;
      font-weight: 400;
      color: @expertFontColor153;
      line-height: 12px;
      margin-top: 8px;
    }

    .record-btn {
      display: inline-block;
      width: 6px;
      height: 11px;
      background: url(../../../assets/images/babyGranary/right.jpg) no-repeat;
      background-size: 6px 11px;
      position: absolute;
      top: 32px;
      right: 13px;
    }
  }

  //商品列表
  .product-list-wrap {
    margin-top: 20px;
    //height: 838px;
    .product-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      display: flex;

      .product-item {
        width: 170px;
        height: 263px;
        padding: 14px 10px;
        box-sizing: border-box;
        border-radius: 8px;
        margin-bottom: 14px;
        background: #fff;
        //margin-right: 9px;
        img {
          width: 134px;
          height: 134px;
          margin-left: 8px;
          margin-bottom: 8px;
        }

        .product-title {
          font-size: 14px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
          width: 143px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .product-desc {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 17px;
          margin-top: 4px;
          width: 150px;
          height: 34px;
          //white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .product-price {
          font-size: 12px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: rgba(253, 110, 64, 1);
          line-height: 17px;
          margin-top: 8px;
        }

        .product-price-line {
          color: #c1c1c1;
          text-decoration: line-through;
        }
      }
    }
  }

  //底线
  .granary-bottom {
    height: 30px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(204, 204, 204, 1);
    margin: 0 auto;
    line-height: 30px;
    text-align: center;
    margin-top: 10px;
  }

  //弹窗
  .granary-popup {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);

    .popup {
      width: 300px;
      height: 356px;
      border-radius: 8px;
      background: @expertFontColor255;
      position: relative;
      top: 83px;
      left: 38px;

      .pop-close {
        text-align: right;
        padding-top: 10px;
        padding-right: 10px;

        span {
          display: inline-block;
          width: 21px;
          height: 21px;
          background: url(../../../assets/images/babyGranary/close.jpg) no-repeat center center;
          background-size: 13px 13px;
        }
      }

      .pop-title {
        font-size: @indexFontSize18;
        font-weight: bold;
        color: rgba(52, 55, 58, 1);
        line-height: 18px;
        text-align: center;
        margin-top: 10px;
      }

      .pop-desc {
        width: 238px;
        font-size: @indexFontSize12;
        color: rgba(34, 34, 34, 1);
        line-height: 18px;
        margin: 17px auto 8px;
        text-align: center;
      }

      .desc {
        font-size: @indexFontSize12;
        font-weight: bold;
        color: @mainColor;
        line-height: 12px;
        text-align: center;
      }

      .pop-img {
        width: 86px;
        height: 86px;
        background: url(../../../assets/images/babyGranary/pop.jpg) no-repeat center center;
        background-size: 86px 86px;
        margin: 6px auto 1px;
      }

      .pop-bottom {
        height: 12px;
        font-size: @indexFontSize12;
        color: @mainColor;
        line-height: 12px;
        text-align: center;
      }

      .pop-btn {
        width: 140px;
        height: 36px;
        background: linear-gradient(270deg,
        rgba(212, 164, 55, 1) 0%,
        rgba(229, 191, 93, 1) 100%);
        border-radius: 23px;
        font-size: @indexFontSize18;
        color: @expertFontColor255;
        line-height: 36px;
        text-align: center;
        margin: 30px auto 0;
      }
    }
  }

  //联系导购弹窗
  .contact {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    display: none;

    .contact-tel {
      width: 270px;
      height: 112px;
      background: @expertFontColor255;
      border-radius: 4px;
      margin-top: 213px;
      margin-left: 52px;

      .contact-num {
        text-align: center;
        padding-top: 17px;
        border-bottom: 1px solid #e5e5e5;

        .phone {
          font-size: 18px;
          font-weight: 400;
          color: @expertFontColor51;
          line-height: 18px;
          margin-bottom: 12px;
        }

        .desc {
          font-size: 12px;
          color: @expertFontColor153;
          line-height: 12px;
          margin-bottom: 12px;
        }
      }

      .contact-select {
        font-size: 16px;
        font-weight: 500;
        color: @expertFontColor51;
        text-align: center;
        height: 40px;

        .del {
          width: 134px;
          float: left;
          padding-top: 12px;
          border-right: 1px solid #e5e5e5;
        }

        .call {
          display: block;
          width: 134px;
          float: left;
          padding-top: 11px;
          color: @mainColor;
        }
      }
    }
  }

  //食量弹窗
  .edit {
    .edit-popup {
      display: flex;
      height: 16px;
      padding: 0 10px;
      box-sizing: border-box;
      justify-content: space-between;

      .edit-cancel {
        //width:28px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }

      .edit-title {
        //width:128px;
        font-size: 16px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }

      .edit-save {
        //width:28px;
        font-size: 14px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: rgba(212, 164, 55, 1);
        line-height: 16px;
      }
    }

    .edit-warn {
      width: 351px;
      height: 50px;
      //margin-top: 18px;
      background: rgba(255, 248, 234, 1);
      border-radius: 8px;
      padding: 8px 10px 6px 10px;
      box-sizing: border-box;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(212, 164, 55, 1);
      line-height: 18px;
      margin: 18px auto;
    }

    //食量调整
    .granary-adjust {
      .adjust-title {
        // width: 60px;
        // height: 12px;
        // margin: 28px auto 10px;
        // line-height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-align: center;
        width: 100%;
      }

      //滑块
      .adjust-slider {
        width: 300px;
        margin-left: 25px;
        margin: 20px auto 2px;

        .custom-button {
          width: 21px;
          height: 33px;
          background: url(../../../assets/images/icon/milkbottle.png) no-repeat;
          background-size: 21px 33px;
        }
      }

      .adjust-range {
        width: 300px;
        margin-left: 25px;
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
      }

      //描述
      .desc {
        //width:196px;
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 96, 102, 1);
        line-height: 12px;
        margin-top: 28px;
        margin-left: 76px;
      }
    }
  }
}

@media (min-width: 640px) {
  .babyGranary {
    min-height: 100%;
    padding: 0 12px;
    background: rgba(242, 242, 242, 1);
    box-sizing: border-box;

    &.isList {
      height: 100%;
    }

    .granary-con {
      width: 100%;
      height: 100%;
      background: url("../../../assets/images/babyGranary/back.png") no-repeat;
      background-size: 100% 100%;
      border-top: 10px solid #f2f2f2;
      box-sizing: border-box;

      &.isList {
        padding-top: 120px;
        box-sizing: border-box;
      }
    }

    //头部
    .granary-header {
      width: 100%;
      height: 293px;
      overflow: hidden;
      position: relative;

      .header-left {
        margin-left: 75px;
      }

      .header-back {
        padding-top: 6px;

        .van-icon-arrow-left {
          padding-left: 2px;
          text-align: left;
          font-size: @indexFontSize20;
          line-height: 20px;
          float: left;
        }
      }

      .header-img {
        width: 167px;
        height: 180px;
        text-align: center;
        line-height: 196px;

        img {
          width: 100%;
          height: 100%;
        }

        //background: url(.././../assets/images/icon/chongzu.png)  no-repeat center center ;
        //background-size: 52px 52px;
        .img-buduo {
          vertical-align: middle;
          display: inline-block;
        }
      }

      .img-margin {
        margin: 83px 77px 14px 77px;
      }

      .img-marginbuzu {
        margin: 77px 136px 20px 18px;
      }

      .header-paster {
        height: 70px;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        top: 19px;
        left: 1.4rem;
        z-index: 50;
        box-sizing: border-box;
        background: url(../../../assets/images/babyGranary/tiezhi1.png) no-repeat;
        background-size: 97% 100%;

        .header-desc {
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(121, 51, 40, 1);
          line-height: 14px;
          font-size: 0.38rem;
          transform: scale(0.83);
          text-align: center;
        }
      }

      .header-pasterbuzu {
        width: 88px;
        height: 63px;
        position: absolute;
        //padding: 18px 0px 6px 0px;
        top: 26px;
        left: 2.8rem;
        z-index: 50;
        box-sizing: border-box;
        background: url(../../../assets/images/babyGranary/tiezhi2.png) no-repeat;
        background-size: 100% 100%;

        .header-desc {
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(121, 51, 40, 1);
          line-height: 14px;
          font-size: 12px;
          transform: scale(0.83);
          //text-indent: 8px;
          margin-top: -6px;
          text-indent: 0;

        }
      }

      .header-pasterbuzu {
        .header-desc-chongzu {
          // text-indent: 0;
          // text-align: center;
        }
      }

      //屯粮
      .store-food-second {
        top: 54px !important;
      }

      .recommendTop {
        top: 40px !important;
      }

      .store-food {
        //width: 84px;
        position: absolute;
        top: 109px;
        left: 300px;

        .first-baby {
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          margin-bottom: 14px;

          .intake {
            font-size: 0.43rem;
            //height: 17px;
            color: rgba(102, 102, 102, 1);
            line-height: 17px;
          }

          .intake-weight {
            font-size: 0.43rem;
            color: rgba(12, 135, 50, 1);
            line-height: 18px;
            display: flex;
            align-items: center;

            .point {
              width: 3px;
              height: 3px;
              background: rgba(12, 135, 50, 1);
              border-radius: 50%;

              &.isRed {
                background: #ef6b6b;
              }
            }

            .ml {
              margin: 0 5px 0 6px;

              &.isRed {
                color: #ef6b6b;
              }
            }
          }

          .sys-record {
            width: 2rem;
            height: 17.91px;
            box-sizing: border-box;
            background: rgba(85, 177, 255, 1);
            border-radius: 6px;
            font-size: 0.43rem;
            transform: scale(0.67);
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 17.91px;
            text-align: center;
            margin-left: -5px;
          }
        }

        .header-btn {
          width: 2.2rem;
          height: 24px;
          display: flex;
          align-items: center;
          background: linear-gradient(270deg,
          rgba(215, 168, 92, 1) 0%,
          rgba(231, 196, 121, 1) 100%);
          border-radius: 14px;
          font-size: 0.35rem;
          box-sizing: border-box;
          margin-bottom: 7px;

          span {
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 17px;
          }

          img {
            width: 5px;
            height: 9px;
            margin-left: 5px;
          }
        }
      }
    }

    //内容
    .granary-content {
      height: 310px;
      margin-left: 110px;

      &.isList {
        margin-top: 30px;
      }

      //库存
      .granary-remain {
        height: 237px;
        padding-left: 9px;

        .remain-title {
          padding-top: 20px;
          font-size: @indexFontSize12;
          font-weight: bold;
          color: @expertFontColor51;
          line-height: 1;
        }

        .remain {
          padding-top: 20px;

          .remain-list {
            // width: 363px;
            height: 178px;
            white-space: nowrap;
            overflow-x: auto;

            &.twoMar {
              margin-left: -1rem;
            }

            &.threeMar {
              margin-left: -2.5rem;
            }

            .list-scan,
            .list-item {
              display: inline-block;
              width: 128px;
              height: 168px;
              background: @expertFontColor255;
              box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05);
              border-radius: 8px;
              margin-right: 9px;
            }

            //扫一扫
            .list-scan {
              text-align: center;
              position: relative;
              // top: -3px;

              //扫一扫
              .scan-img {
                text-align: center;

                img {
                  width: 56px;
                  height: 56px;
                  margin-top: 38px;
                }
              }

              .scan-desc {
                text-align: center;
                white-space: pre-wrap;
                margin: 17px auto;
                width: 90px;
                height: 36px;
                font-size: @indexFontSize12;
                color: rgba(180, 180, 180, 1);
                line-height: 18px;
              }
            }

            .list-item {
              display: inline-block;

              .item-img {
                width: 78px;
                height: 78px;
                margin-top: 13px;
                margin-left: 23px;
                background: url(../../../assets/images/babyGranary/03granary.png) no-repeat;
                background-size: 78px 78px;

                img {
                  width: 100%;
                  height: 78px;
                  display: block;
                }
              }

              .item-desc {
                padding-left: 8px;
                padding-top: 20px;
                font-size: @indexFontSize12;
                line-height: 1;
                white-space: nowrap;
                width: 110px;
                text-overflow: ellipsis;
                overflow: hidden;
              }

              .item-num {
                margin-left: 8px;
                margin-top: 11px;
                height: 26px;
                display: flex;

                span {
                  color: @expertFontColor153;
                  font-size: @indexFontSize12;
                  line-height: 14px;
                  margin-right: 14px;
                }

                //步进器
                .item-step {
                  display: flex;
                  width: 53px;

                  .minus,
                  .add {
                    width: 14px;
                    height: 14px;
                    background-size: 14px 14px;
                  }

                  .minus {
                    background: url(../../../assets/images/babyGranary/minus.jpg) no-repeat;
                    background-size: 14px 14px;
                  }

                  .add {
                    background: url(../../../assets/images/babyGranary/add.jpg) no-repeat;
                    background-size: 14px 14px;
                  }

                  .num {
                    width: 25px;
                    font-size: @indexFontSize14;
                    color: @expertFontColor51;
                    line-height: 14px;
                    text-align: center;
                  }

                  //    .active{
                  //        color: red;
                  //    }
                }
              }
            }
          }
        }
      }
    }

    //记录
    .granary-record {
      border-top: 1px solid rgba(212, 164, 55, 1);
      height: 72px;
      padding-left: 9px;
      position: relative;
      margin-left: -110px;

      .record-title {
        height: 16px;
        font-size: @indexFontSize12;
        font-weight: bold;
        color: @expertFontColor51;
        line-height: 16px;
        padding-top: 20px;
        margin-left: 115px;
      }

      .record-desc {
        height: 12px;
        font-size: @indexFontSize12;
        font-family: PingFangSC;
        font-weight: 400;
        color: @expertFontColor153;
        line-height: 12px;
        margin-top: 8px;
        margin-left: 115px;
      }

      .record-btn {
        display: inline-block;
        width: 6px;
        height: 11px;
        background: url(../../../assets/images/babyGranary/right.jpg) no-repeat;
        background-size: 6px 11px;
        position: absolute;
        top: 32px;
        right: 13px;
      }
    }

    //商品列表
    .product-list-wrap {
      margin-top: 20px;
      //height: 838px;
      .product-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        display: flex;

        .product-item {
          width: 240px;
          height: 263px;
          padding: 14px 40px;
          box-sizing: border-box;
          border-radius: 8px;
          margin-bottom: 14px;
          background: #fff;
          //margin-right: 9px;
          img {
            width: 134px;
            height: 134px;
            margin-left: 8px;
            margin-bottom: 8px;
          }

          .product-title {
            font-size: 14px;
            font-family: PingFang-SC-Medium, PingFang-SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            line-height: 20px;
            width: 143px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .product-desc {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 17px;
            margin-top: 4px;
            width: 150px;
            height: 34px;
            //white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .product-price {
            font-size: 12px;
            font-family: PingFang-SC-Medium, PingFang-SC;
            font-weight: 500;
            color: rgba(253, 110, 64, 1);
            line-height: 17px;
            margin-top: 8px;
          }
        }
      }
    }

    //底线
    .granary-bottom {
      height: 30px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(204, 204, 204, 1);
      margin: 0 auto;
      line-height: 30px;
      text-align: center;
      margin-top: 10px;
    }

    //弹窗
    .granary-popup {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.6);

      .popup {
        width: 300px;
        height: 356px;
        border-radius: 8px;
        background: @expertFontColor255;
        position: relative;
        top: 83px;
        left: 38px;

        .pop-close {
          text-align: right;
          padding-top: 10px;
          padding-right: 10px;

          span {
            display: inline-block;
            width: 21px;
            height: 21px;
            background: url(../../../assets/images/babyGranary/close.jpg) no-repeat center center;
            background-size: 13px 13px;
          }
        }

        .pop-title {
          font-size: @indexFontSize18;
          font-weight: bold;
          color: rgba(52, 55, 58, 1);
          line-height: 18px;
          text-align: center;
          margin-top: 10px;
        }

        .pop-desc {
          width: 238px;
          font-size: @indexFontSize12;
          color: rgba(34, 34, 34, 1);
          line-height: 18px;
          margin: 17px auto 8px;
          text-align: center;
        }

        .desc {
          font-size: @indexFontSize12;
          font-weight: bold;
          color: @mainColor;
          line-height: 12px;
          text-align: center;
        }

        .pop-img {
          width: 86px;
          height: 86px;
          background: url(../../../assets/images/babyGranary/pop.jpg) no-repeat center center;
          background-size: 86px 86px;
          margin: 6px auto 1px;
        }

        .pop-bottom {
          height: 12px;
          font-size: @indexFontSize12;
          color: @mainColor;
          line-height: 12px;
          text-align: center;
        }

        .pop-btn {
          width: 140px;
          height: 36px;
          background: linear-gradient(270deg,
          rgba(212, 164, 55, 1) 0%,
          rgba(229, 191, 93, 1) 100%);
          border-radius: 23px;
          font-size: @indexFontSize18;
          color: @expertFontColor255;
          line-height: 36px;
          text-align: center;
          margin: 30px auto 0;
        }
      }
    }

    //联系导购弹窗
    .contact {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.6);
      display: none;

      .contact-tel {
        width: 270px;
        height: 112px;
        background: @expertFontColor255;
        border-radius: 4px;
        margin: 213px auto;

        .contact-num {
          text-align: center;
          padding-top: 17px;
          border-bottom: 1px solid #e5e5e5;

          .phone {
            font-size: 18px;
            font-weight: 400;
            color: @expertFontColor51;
            line-height: 18px;
            margin-bottom: 12px;
          }

          .desc {
            font-size: 12px;
            color: @expertFontColor153;
            line-height: 12px;
            margin-bottom: 12px;
          }
        }

        .contact-select {
          font-size: 16px;
          font-weight: 500;
          color: @expertFontColor51;
          text-align: center;
          height: 40px;

          .del {
            width: 134px;
            float: left;
            padding-top: 12px;
            border-right: 1px solid #e5e5e5;
          }

          .call {
            display: block;
            width: 134px;
            float: left;
            padding-top: 11px;
            color: @mainColor;
          }
        }
      }
    }

    //食量弹窗
    .edit {
      .edit-popup {
        display: flex;
        height: 16px;
        padding: 0 10px;
        box-sizing: border-box;
        justify-content: space-between;

        .edit-cancel {
          //width:28px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 16px;
        }

        .edit-title {
          //width:128px;
          font-size: 16px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 16px;
        }

        .edit-save {
          //width:28px;
          font-size: 14px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: rgba(212, 164, 55, 1);
          line-height: 16px;
        }
      }

      .edit-warn {
        width: 351px;
        height: 50px;
        margin-top: 18px;
        background: rgba(255, 248, 234, 1);
        border-radius: 8px;
        padding: 8px 10px 6px 10px;
        box-sizing: border-box;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(212, 164, 55, 1);
        line-height: 18px;
      }

      //食量调整
      .granary-adjust {
        .adjust-title {
          // width: 60px;
          // height: 12px;
          // margin: 28px auto 10px;
          // line-height: 12px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          text-align: center;
          width: 100%;
        }

        //滑块
        .adjust-slider {
          width: 300px;
          margin-left: 25px;
          margin: 10px auto 2px;

          .custom-button {
            width: 21px;
            height: 33px;
            background: url(../../../assets/images/icon/milkbottle.png) no-repeat;
            background-size: 21px 33px;
          }
        }

        .adjust-range {
          width: 300px;
          margin-left: 25px;
          display: flex;
          justify-content: space-between;
          margin: 0 auto;
        }

        //描述
        .desc {
          //width:196px;
          height: 12px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 96, 102, 1);
          line-height: 12px;
          margin-top: 18px;
          margin-left: 156px;
        }
      }
    }
  }
}
</style>

<script>
import {Debounce, getCookie, is_weixin} from "@/assets/js/common.js";
import granaryDialog from "@/components/contents/granaryDialog.vue";
import {setTimeout} from 'timers';
import {Exposurer_home} from '../../../assets/js/Exposure'

export default {
  name: "babyGranary",
  components: {
    // [Dialog.Component.name]: Dialog.Component,
    granaryDialog
  },
  data() {
    return {
      num: 1, //计步器
      num1: 1,
      slider: 0, //滑块
      title: [],
      logShow: false, //弹窗
      remainList: [],
      isActive: 0,
      isMargin: null,//ipad端奶粉罐左边距
      granaryBtn: false, //补仓按钮
      onLine: true, //线上线下
      staffCode: "", //导购码
      staffMobile: "", //导购电话
      firstBabyName: "", //一胎名字
      secondBabyName: "", //二胎名字
      memberFirstWeight: "", //一胎食量摄入
      memberWeight: "", //一胎是否系统推荐
      memberSecondWeight: "", //二胎食量
      memberWeightSecond: "", //二胎是否系统推荐
      totalDays: "",
      wx_config: "", //微信配置
      btn: false,
      month: 6, //月龄
      systemWeight: 100, //系统食量
      userInfo: {}, //用户信息
      lastSlider: 0, //保存上一次的滑块食量
      statrImage: "chongzu.png",
      bucangFlag: false, //马上补仓标志
      chongzuFlag: false, //余粮充足标志
      editShow: false, //食量调整弹出框
      editFlag: false, //食量调整弹出框标志
      orderList: null, //库存订单数量（买过的）
      flag_scroll: false,
      loading: false,
      finished: false,
      page: 1,
      itemList: [], //列表原有数据
      newList: [],
      code: "", //会员等级
      size: "20", //分页列表查询条数
      babyName: "",
      firstMonth: "",
      secondMonth: "",
      flag: 3, //保存的是一胎还是二胎
      isShow: true, //二胎
      isShowFirst: true, //一胎
      storeFlag: false,
      babyList: [],
      isRed: false,
      jianyiFlag: false,
      scrollWatch: true,
      scrollTop: '',
      requestId: '',
      itemSetId: '',
      sceneId: '',
      startMomList: [],
      startMomFlag: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit("changeIncludes", ["home", "babyGranary"]);
    });
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    //this.getCode();
    var shareDataParams = {
      shareLink: this.$http.hostName + "/home",
      shareDesc: "1000万中国家庭都在看！科学育儿，全程陪伴，源于母爱。",
      shareTitle: "星妈会",
      imgUrl: "https://image-mom.feihe.com/wxshare/home.png" //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
  },
  async mounted() {
    this.getBabyInfo();
    await this.getCode();
    this.getroadList();
    await this.getLastOrder();
    this.getGranaryIndex();
    if (this.scrollWatch) {
      window.addEventListener('scroll', this.handleScroll);
    }
    var date = Date.parse(new Date());
    var id = this.getCookie('xmh_unionid');
    this.requestId = this.$md5(date + id);
    if (this.$http.hostName == 'https://mom.feihe.com') { // 正式环境物料id和服务id
      this.itemSetId = '24'
      this.sceneId = '40'
    } else {  // uat环境物料id和服务id
      this.itemSetId = '17'
      this.sceneId = '29'
    }
    setTimeout(() => {
      Exposurer_home.observe('.product-item', false, {List: this.itemList, that: this, type: "babyGranary"});
    }, 3000)
  },
  beforeDestroy() {
    this.scrollWatch = false
    window.removeEventListener('scroll', this.handleScroll);
  },
  updated() {

  },
  methods: {
    getCookie,
    handleScroll() {
      this.scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let top1 = $('.babyGranary').offset().top;
      let top2 = $(document).scrollTop();
      let top = top1 - top2;
      if (this.scroll > top1) {
        let t1 = 0;
        let t2 = 0;
        let timer2 = null; // 定时器
        document.onscroll = function () {
          clearTimeout(timer2);
          timer2 = setTimeout(isScrollEnd, 300);
          t1 = document.documentElement.scrollTop || document.body.scrollTop;
        }

        function isScrollEnd() {
          t2 = document.documentElement.scrollTop || document.body.scrollTop;
          var path;
          if (t2 == t1) {
            path = require('../../../assets/images/icon/back1.png')
            $(".backimg").attr('src', path);
          } else {
            path = require('../../../assets/images/icon/back2.png')
            $(".backimg").attr('src', path);
          }
        }
      }
    },
    //获取宝宝信息
    getBabyInfo() {
      var babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
      if (babyInfo) {
        this.handlerInfo(babyInfo)
      } else {
        this.$http.get(
            "/starMom/getBaby",
            {crmId: this.userInfo.crm_id},
            res => {
              if (res.code == "200") {
                this.handlerInfo(res.data)
              }
            },
            err => {
            }, "member"
        );
      }
    },
    handlerInfo(res) {
      if (res.length > 1) {
        //二胎
        //二胎是否展示
        this.babyList = res;
        res.forEach((item, index) => {
          if (item.num == 1) {
            if (item.tag_id * 1 > 2) {
              this.isShowFirst = true;
              this.isShow = false;
              this.firstBabyName = item.nick == '' ? '鹤小宝' : item.nick;
            } else {
              this.isShowFirst = false;
            }
          } else {
            if (item.tag_id * 1 > 2) {
              this.isShow = true;
              this.secondBabyName = item.nick == '' ? '鹤小宝' : item.nick;
            } else {
              this.isShow = false;
            }
          }
        });
      } else if (res.length == 1) {
        this.babyList = res;
        localStorage.setItem("babyNum", res.length);
        this.firstBabyName = res[0].nick;
        this.isShow = false; //二胎不显示
      } else {
        localStorage.setItem("babyNum", 0);
      }
    },
    //获取星妈等级
    getCode() {
      return new Promise((reslove, reject) => {
        this.$http.get(
            "/newMember/getUserGrade",
            {crmId: this.userInfo.crm_id},
            res => {
              if (res.code == "200") {
                this.code = res.data.code;
                reslove(this.code);
              }
            },
            err => {
            }, "lucky"
        );
      });
    },
    //推荐列表
    getroadList(code) {
      this.$http.post(
          "/recommendProduct/productFrontList",
          {crmId: this.userInfo.crm_id, staMotherLevel: this.code},
          //{ crmId: "CRM000000000041930480", staMotherLevel: '31'},
          {page: this.page, size: 20},
          res => {
            if (res.code == 200) {
              if (this.page >= '2') {
                this.startMomFlag = true
              }
              this.startMomList = []
              const productList = res.data.data;
              res.data.data.forEach((item) => {
                gio('track', 'babybarnb_recommendproduct_exp');
                // sensors.track('BabybarnbExpRecommendproduct');
              })
              if (productList.length === 0) {
                // 判断获取数据条数若等于0
                this.finished = true; // 停止加载
              }
              this.itemList = productList
              // productList.forEach((item, index) => {
              //   item.finalPrice != null ? this.itemList.push(item) : "";
              //   item.finalPrice != null ? this.startMomList.push(item) : "";
              // });

              this.loading = false;
              //this.itemList.push(...productList)
              if (this.itemList.length >= res.data.totalElements) {
                this.finished = true;
              }
            }
          }
      );
    },
    // 点击商品跳星妈优选
    toProduct(item, index) {
      gio('track', "babybarnb_recommendproduct");
      // sensors.track('BabybarnbClickRecommendproduct');

      sensors.track('ProductClick', {
        commodity_class1: item.firstCategory,
        commodity_class2: item.secCategory,
        commodity_id: item.sku,
        commodity_name: item.recommendGoods,
        cash_number: item.promotion_type == 8 ? item.price * 1 : 0,
        point_number: item.point_price,
        operate_name: '宝宝粮仓底部推荐',
        operate_content: '商品推荐',
        itemSetId: this.itemSetId,
        sceneId: this.sceneId,
        context: '',
        requestId: this.requestId,
        $title: this.$route.meta.title,
        position: index + 1,
      });
      var that = this;
      setTimeout(function () {
        location.href = item.jumpUrl + '&xmhSource=bblcShop'
      }, 200)
    },
    //滚动加载时触发，list组件定义的方法
    onLoad() {
      this.page++;
      this.getroadList();
    },
    //保存食量设置
    saveEdit() {
      this.editShow = false;
    },
    //编辑粮仓
    editGranary(num) {
      if (!this.editFlag) {
        return
      } else {
        gio('track', "babybarnb_set");
        // sensors.track('BabybarnbSet');
        this.editShow = true
      }
      if (num == 1) {
        this.lastSlider = this.memberFirstWeight;
        this.slider = this.memberFirstWeight;
        this.babyName = this.firstBabyName;
        this.month = this.firstMonth;
        this.systemWeight = this.systemfirstWeight;
        this.flag = 1;
      } else if (num == 2) {
        this.lastSlider = this.memberSecondWeight;
        this.slider = this.memberSecondWeight;
        this.babyName = this.secondBabyName;
        this.month = this.secondMonth;
        this.systemWeight = this.systemsecondWeight;
        this.flag = 2;
      } else {
        this.flag = 3;
      }
    },
    toHomeHander() {
      this.$router.push("/home");
      // if(this.getCookie('fromPath')){
      //     // window.history.go(-1)
      //     this.$router.go(-1)
      // }else{
      //     this.$router.push('/home')
      // }
    },
    //弹窗
    closePopupHander() {
      this.popup = false;
    },
    //判断当前点击的元素
    clickHander(index) {
      this.isActive = index;
    },
    minusHander(index) {
      this.btn = true;
      if (this.remainList[index].num == 1) {
        this.$dialog
            .confirm({
              message: "确定从当前库存中删除该品项？",
              confirmButtonText: "确定删除",
              confirmButtonColor: "#D4A437",
              cancelButtonColor: "#333"
            })
            .then(() => {
              this.remainList[index].num--;
              this.saveHander(2, false);
            })
            .catch(() => {
            });
        return;
      } else {
        this.remainList[index].num--;
        this.saveHander(2, true);
      }
      //gio("track", "babyBarnCount", { function_var: "调整库存" });
      gio("track", "babybarnb_adjustinventory");
      sensors.track('BabybarnbAdjustInventory');

    },
    addHander(index) {
      sensors.track('BabybarnbAdjustInventory');
      this.btn = true;
      this.remainList[index].num++;
      this.saveHander(3, true);
      gio("track", "babybarnb_adjustinventory");
      sensors.track('BabybarnbAdjustInventory');
    },
    //粮仓初始信息
    getGranaryIndex() {
      var isBought = localStorage.getItem('isBought')
      var isFollow = localStorage.getItem('isFollow')
      var userGrade = localStorage.getItem('userGrade')
      this.$http.post(
          "/granary/detail/index", {crmId: this.userInfo.crm_id,},
          {is_bought: isBought, user_level: userGrade, is_follow: isFollow},
          res => {
            if (res.code === "200") {
              if (res.data.productArgs.length < 0) {
              } else {
                //有数据
                this.remainList = res.data.productArgs;
                // if (this.remainList != "") {
                //   this.editFlag = true;
                //   $(".list-scan").css("top", "-3px");
                // } else {
                //   this.editFlag = false;
                //   $(".list-scan").css("top", "0");
                // }
                this.totalDays = res.data.totalDays;
                this.babyList.forEach((item, index) => {
                  if (item.num == 1 && item.tag_id * 1 > 2) {
                    this.memberFirstWeight = res.data.memberFirstWeight; //一胎食量
                    this.firstMonth = res.data.babyMonth;
                    this.systemfirstWeight = res.data.sysFirstWeight;
                  } else if (item.num == 2 && item.tag_id * 1 > 2) {
                    this.memberSecondWeight = res.data.memberSecondWeight; //二胎食量
                    this.secondMonth = res.data.babyMonthSecond;
                    this.systemsecondWeight = res.data.sysSecondWeight;
                  }
                });

                if (res.data.productArgs.length > 0) {
                  if (res.data.productArgs.length == 1) {
                    this.isMargin = null
                  } else if (res.data.productArgs.length == 2) {
                    this.isMargin = 2
                  } else if (res.data.productArgs.length > 2) {
                    this.isMargin = 3
                  }

                  res.data.productArgs[0].memberWeight == 0
                      ? (this.memberWeight = true)
                      : (this.memberWeight = false);
                  res.data.productArgs[0].memberWeightSecond == 0
                      ? (this.memberWeightSecond = true)
                      : (this.memberWeightSecond = false);
                  if (this.memberWeight == 0 || this.memberWeight == '' || this.memberWeight == null) {
                    gio('page.set', {'babybarnb_food': '未设置'});
                  } else {
                    gio('page.set', {'babybarnb_food': '已设置'});
                  }

                  res.data.productArgs.forEach(item => {
                    this.title.push(item.productName.split("段")[0] + "段奶粉");
                  });
                }
                //首次进入
                if (
                    localStorage.getItem("firstEnter") == "" ||
                    !localStorage.getItem("firstEnter")
                ) {
                  this.$toast({
                    duration: 2000,
                    message: "若库存有误可手动纠正",
                    forbidClick: true, //禁用背景点击
                    context: this
                  });
                  localStorage.setItem("firstEnter", "hello");
                }
              }
              if (res.data.babyMonth >= 0 || res.data.babyMonthSecond >= 0) {
                if (res.data.totalDays >= 21) {
                  $(".header-desc").html("奶粉余粮充足");
                  this.isRed = false;
                  this.bucangFlag = false;
                  this.chongzuFlag = true;
                  this.granaryBtn = true;
                  this.storeFlag = true;
                  this.statrImage = "chongzu.png";
                  this.editFlag = true
                } else if (res.data.totalDays >= 7 && res.data.totalDays < 21) {
                  $(".header-desc").html("吃一半啦~");
                  this.isRed = false;
                  this.bucangFlag = false;
                  this.chongzuFlag = true;
                  this.storeFlag = true;
                  this.statrImage = "yiban.png";
                  this.editFlag = true
                } else {
                  if (
                      res.data.productArgs.length == 0 &&
                      this.orderList == null
                  ) {
                    $(".header-desc").html(
                        "建议先购买飞鹤奶粉哦~<br/>宝宝粮仓帮您科学记录宝宝食量,<br/>健康喂养每一天"
                    );
                    this.memberWeight = true
                    this.memberWeightSecond = true
                    this.storeFlag = true;
                    this.granaryBtn = false;
                    this.statrImage = "chongzu.png";
                    this.jianyiFlag = true
                    this.bucangFlag = false
                    this.totalDays = "- -"
                    this.editFlag = false
                  } else if (
                      res.data.productArgs.length == 0 &&
                      !!this.orderList
                  ) {
                    this.storeFlag = true;
                    $(".header-desc").html("空空如也<br/>尽快补仓呦~");
                    this.isRed = true;

                    this.bucangFlag = true;
                    this.statrImage = "kongkong.png";
                    this.editFlag = false
                  } else {
                    this.storeFlag = true;
                    $(".header-desc").html("余粮不足，<br/>尽快补仓呦~");
                    this.isRed = true;
                    this.granaryBtn = true;
                    this.bucangFlag = true;
                    this.statrImage = "buduo.png";
                    this.editFlag = true
                  }
                }
              }
            }
          }
      );
    },
    //最近一单
    getLastOrder() {
      return new Promise((reslove, reject) => {
        this.$http.post(
            "/granary/orderList",
            {crmId: this.userInfo.crm_id},
            {data: {}, page: 1, size: 10},
            res => {
              if (res.code == 200) {
                this.orderList = res.data.content.data;
                this.onLine = res.data.content.data[0].onLine;
                this.staffCode = res.data.content.data[0].staffCode;
                this.staffMobile = res.data.content.data[0].staffMobile;
                reslove(this.orderList);
              } else {
                if (res.code == 500) {
                  this.orderList = null;
                  this.onLine = true;
                  reslove(this.orderList);
                }

                //reslove(this.onLine);
              }
            }
        );
      });
    },
    // 点击继续屯粮按钮
    continueFood: function () {
      gio('track', "babybarnb_buy");
      sensors.track('BabybarnbBuy');
      sensors.track('ContinueAddProduct')
      if (this.onLine) {
        //去商城
        setTimeout(() => {
          location.href = "http://m.feihe.com";
        }, 300)
      } else {
        // 联系导购
        $(".contact").fadeIn(100);
        $(".body").css("overflow", "hidden");
      }
    },
    //保存
    saveHander: Debounce(function (order, bool) {
      this.editShow = false;
      if (this.btn) {
        if (this.lastSlider != this.slider) {
          gio("track", "babyBarnCount", {function_var: "调整宝宝食量"});
          sensors.track('BabybarnbSet', {BabybarnbSetOperate: '调整'});
        }

        if (this.remainList) {
          this.remainList.forEach(item => {
            if (this.flag == 1) {
              item.memberWeight = this.slider;
            } else if (this.flag == 2) {
              item.memberWeightSecond = this.slider;
            } else if (this.flag == 3) {
              item.memberWeight = this.memberFirstWeight;
              item.memberWeightSecond = this.memberSecondWeight;
            }
          });
          this.$http.post("/granary/update", {}, this.remainList, res => {
            if (res.code === "200") {
              gio('track', "babybarnb_set_save");
              sensors.track('BabybarnbSet', {BabybarnbSetOperate: '保存'});
              if (order == 2 || order == 3) {
                if (bool) {
                  this.$toast({
                    message: `已成功为您${order == 3 ? "添加" : "删除"
                    }1罐奶粉!`,
                    forbidClick: true,
                    duration: 3000,
                    context: this
                  });
                }
              }
              this.btn = false;

              this.getGranaryIndex();
            }
          });
        }
      }
    }, 500),
    // 取消修改弹窗
    cancelHander() {
      gio('track', "babybarnb_set_cancel");
      sensors.track('BabybarnbSet', {BabybarnbSetOperate: '取消'});
      this.editShow = false
    },
    toListHander() {
      gio('track', "babybarnb_viewrecords");
      sensors.track('BabybarnbInventoryRecords');
      var that = this;
      setTimeout(function () {
        that.$router.push({path: '/babyGranary/stockList'});
      }, 200)
    },
    //关闭弹窗
    cancelDialog(flag) {
      this.logShow = flag;
    },

    //微信扫码
    weiScanSHnader() {
      if (is_weixin()) {
        if (!localStorage.getItem("isWxScan")) {
          this.logShow = true;
          localStorage.setItem("isWxScan", true);
        } else {
          sensors.track('ScanAddProduct', {exist_product_quantity: this.orderList != null ? this.orderList.length : '0'})
          gio("track", "babybarnb_addmilk");
          this.logShow = false;
          this.wxJsSet.wxShare("sm", "", this);
        }
      } else {
        this.$toast({
          message: "请在微信端打开",
          forbidClick: true,
          duration: 2000,
          context: this
        });
      }
    },
    onChange(value) {

      // this.curSlider = this.slider;
      // this.slider=value

      gio('track', "babybarnb_set_adjust");


      if (!this.remainList.length) {
        this.btn = false;
      } else {
        this.btn = true;
      }
    },
    // onInput(value){

    //    this.sliderTitle=value
    // },
    delTelHander() {
      $(".contact").fadeOut(100);
      $("body").css("overflow", "scroll");
    }
  },
  watch: {
    itemList(val) {
      if (val.length < 0) {
        return;
      }
      val.forEach(item => {
        if (item.finalPrice == null) {
          //item.finalPrice = "a";
        } else {
          if (item.finalPrice.indexOf("+") != -1) {
            //有现金
            const arr = item.finalPrice.split("积分+￥");
            const num = arr[1] * 1;
            item.finalPrice = Math.round(arr[0]) + "积分+￥" + num.toFixed(2);
          } else if (item.finalPrice.indexOf("￥") != -1) {
            const arr = item.finalPrice.split("￥");
            item.finalPrice = "￥" + (arr[1] / 100).toFixed(2);
          } else {
            const arr = item.finalPrice.split("积分");
            item.finalPrice = Math.round(arr[0]) + "积分";
          }
        }
      });
    },
    scrollTop: {
      handler() {
        this.handleScroll()
      }
    }
  }
};
</script>
